export const NAMES_MAX = 40

const NOT_PRINTABLE = /[^A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F\u1E00-\u1EFF &'’-]/g

export function printableNames(value: string) {
  return value
    .normalize('NFC')
    .replace(/\s/g, ' ')
    .replace(NOT_PRINTABLE, '')
    .replace(/ {2,}/g, ' ')
}
